import { makeStyles } from '@material-ui/core/styles';

// Palete de colors aqui: https://material-ui.com/customization/palette/

import { complementaryColor } from '../utils/constants';

export const menuDrawerList = makeStyles(() => ({
  root: {
    width: '100%',
    background: complementaryColor,
    flexGrow: 1,
  },
  nested: {
    margin: 0,
    width: '100%',
  },
  white: {
    color: '#ffffff',
  },
}));

export const menuDrawerAvatar = makeStyles((theme) => ({
  root: {
    width: 280,
    flexGrow: 1,
    background: complementaryColor,
  },
  container: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: 120,
    heigth: 120,
  },
}));


// *********************** MENU DRAWER ***********************
// listContainer: {
//  backgroundColor: complementaryColor,
//  width: 250,
//  flexGrow: 1,
// },
